import React from "react";
import { message, Form } from "antd";
import styled from "styled-components";
import { PlusOutlined } from "@ant-design/icons";

import Button from "components/buttons/Button";
import Input from "components/inputs/Input";
import NumberInput from "components/inputs/NumberInput";
import Select from "components/inputs/Select";
import Fetch from "components/Fetch";
import colors from "constants/palette";

export default function Customers({ setData, oldData, handleCancel }) {
  const [form] = Form.useForm();

  const [loading, setLoading] = React.useState(false);

  const onSubmit = (data) => {
    const submitData = { ...data, data: JSON.stringify({}) };
    setLoading(true);
    if (!oldData) {
      // new :::::::::::::
      Fetch.post("/customer", submitData, (res) => {
        console.log("new customer response", res);
        if (res?.id) {
          message.success("با موفقیت اضافه شد");
          cleanForm();
          setData((e) => [...e, res]);
        } else {
          if (res?.errors.title) {
            message.error(res?.errors.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    } else {
      // update :::::::::
      Fetch.put(`/customer/${oldData.id}`, submitData, (res) => {
        console.log("new customer response/UPDATE", res);
        if (res?.id) {
          message.success("با موفقیت آپدیت شد");

          setData((e) => {
            var newData = e;
            newData[e.findIndex((item) => item.id === res.id)] = res;
            console.log("newData", newData);
            return newData;
          });

          handleCancel();
          cleanForm();
        } else {
          if (res?.errors?.title) {
            message.error(res?.errors.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    }
    setLoading(false);
  };

  function cleanForm() {
    form.resetFields();
  }
  if (oldData) {
    form.setFieldsValue(oldData);
  }

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ direction: "rtl" }}
      name={oldData ? "update" : "new"}
      onFinish={onSubmit}
    >
      <Label>نام مشتری :</Label>
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: "لطفا نام مشتری را وارد کنید!",
          },
        ]}
      >
        <Input size="large" placeholder="" />
      </Form.Item>
      <Label>نام فروشگاه :</Label>
      <Form.Item
        name="shop"
        rules={[
          {
            required: true,
            message: "لطفا نام فروشگاه را وارد کنید!",
          },
        ]}
      >
        <Input size="large" placeholder="" />
      </Form.Item>
      <Label>تلفن ثابت :</Label>
      <Form.Item name="telephone">
        <NumberInput style={{ width: "100%" }} placeholder="" />
      </Form.Item>
      <Label>تلفن همراه :</Label>
      <Form.Item
        name="phone"
        rules={[
          {
            required: true,
            message: "لطفا تلفن همراه را وارد کنید!",
          },
        ]}
      >
        <NumberInput style={{ width: "100%" }} placeholder="" />
      </Form.Item>
      <Label>شهر :</Label>
      <Form.Item
        name="city"
        rules={[
          {
            required: true,
            message: "لطفا شهر را وارد کنید!",
          },
        ]}
      >
        <Select
          list={cities}
          showSearch
          placeholder="جستجو"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          filterSort={(optionA, optionB) =>
            optionA.children
              .toLowerCase()
              .localeCompare(optionB.children.toLowerCase())
          }
          borderradius="2px"
          style={{ minWidth: "100%" }}
        />
      </Form.Item>
      <Label>آدرس :</Label>
      <Form.Item
        name="address"
        rules={[
          {
            required: true,
            message: "لطفا آدرس را وارد کنید!",
          },
        ]}
      >
        <Input size="large" placeholder="" />
      </Form.Item>

      <Button
        loading={loading}
        htmlType="submit"
        style={{ width: "100%", marginTop: 16 }}
      >
        {oldData ? (
          "اصلاح"
        ) : (
          <span>
            <PlusOutlined style={{ marginLeft: 8 }} />
            اضافه کردن
          </span>
        )}
      </Button>
    </Form>
  );
}

const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
const cities = [
  "آمل",
  "بابل",
  "بابلسر",
  "بلده",
  "بهشهر",
  "پل سفيد",
  "تنكابن",
  "جويبار",
  "چالوس",
  "خرم آباد",
  "رامسر",
  "رستم کلا",
  "ساري",
  "سلمانشهر",
  "سواد كوه",
  "فريدونكنار",
  "قائم شهر",
  "گلوگاه",
  "محمودآباد",
  "مرزن آباد",
  "نكا",
  "نور",
  "نوشهر",
  "امیرکلا",
  "کتالم وسادات شهر",
  "زیرآب",
  "عباس‌آباد",
  "خلیل شهر",
  "شیرود",
  "چمستان",
  "کلاردشت",
  "هچیرود",
  "ارطه",
  "سورک",
  "شیرگاه",
  "بهنمیر",
  "کیاکلا",
  "هادی‌شهر",
  "رویان",
  "ایزدشهر",
  "گتاب",
  "سرخرود",
  "نشتارود",
  "کلارآباد",
  "آستانه نو",
  "امامزاده عبدالله",
  "خوش‌رودپی",
  "اجبارکلا",
  "زرگر",
  "کیاسر",
  "پول",
  "کجور",
  "کوهی‌خیل",
  "فرح آباد",
  "طبقده",
  "دابودشت",
  "آکند",
  "آلاشت",
  "رینه",
  "پایین هولار",
  "مرزیکلا",
  "فریم",
  "گزنک",
];
